import io from 'socket.io-client';
import { eventChannel } from 'redux-saga';
import { all, call, put, delay, select, take, fork, } from 'redux-saga/effects';
import { setIsConnected, setSocket } from '../../../state/socket/socketSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import socketSubscribeSaga from '../socketSubscribe/socketSubscribe';
import socketListenersSaga from '../socketListeners/socketListeners';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectEsServer } from '../../../state/config/configSlice';

const SOCKET_CONNECT = 'SOCKET_CONNECT';
const SOCKET_CONNECTION_ERROR = 'SOCKET_CONNECTION_ERROR';
const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
const SOCKET_RECONNECT_ERROR = 'SOCKET_RECONNECT_ERROR';

export default function* connectSocketSaga() {
    const esServer = yield select(selectEsServer);
    const userCredential = yield select(selectUserCredentials)
    const { domain, user } = userCredential;

    try {
        const socket = io(esServer, {
            secure: true,
            transports: ['websocket'],
            perMessageDeflate: false
        });
        yield fork(socketListenersSaga);

        // create channel for callbacks
        const channel = eventChannel((emitter) => {
            socket.on('connect', () => {
                console.debug('connected');
                console.debug('subscriptions', socket.subscriptions);
                emitter(SOCKET_CONNECT);
                socket.subscriptions?.forEach((sub) => socket.emit('subscribe', sub));
            });

            socket.on('disconnect', () => {
                console.debug('disconnected');
                emitter(SOCKET_DISCONNECT);
            });

            socket.on('reconnect_attempt', () => {
                console.debug('reconnect_attempt');
                emitter(SOCKET_RECONNECT_ERROR);
            });

            socket.on('error', () => {
                console.debug('error');
                emitter(SOCKET_CONNECTION_ERROR);
            });

            // unsubscribe method
            return () => {
                socket.disconnect();
            };
        });

        while (true) {
            const res = yield take(channel);
            if (res === SOCKET_DISCONNECT) {
                console.error('Socket disconnected');
                yield put(setIsConnected(false));
                yield put(showSnackbar({
                    message: "Socket connection error",
                    severity: "error"
                }))

            } else if (res === SOCKET_CONNECTION_ERROR) {
                console.error('Socket connection');
                yield put(setIsConnected(false));
                yield put(showSnackbar({
                    message: "Socket connection error",
                    severity: "error"
                }))

            } else if (res === SOCKET_RECONNECT_ERROR) {
                console.error('Initial socket connection');
                yield put(setIsConnected(false));

            } else {
                yield put(setSocket(socket));
                yield put(setIsConnected(true));
                yield delay(1000);

                yield all([
                    call(socketSubscribeSaga, {
                        payload: { type: 'call', filter: user },
                    }),
                    // do not subscribe to chat if user has chat disabled
                    call(socketSubscribeSaga, {
                        payload: { type: 'ucchat', filter: user },
                    }),
                    call(socketSubscribeSaga, {
                        payload: { type: 'voicemail', filter: user },
                    }),
                    call(socketSubscribeSaga, {
                        payload: { type: 'contacts' },
                    }),
                    call(socketSubscribeSaga, {
                        payload: { type: 'agent', user: user, unit: 'seconds' },
                    }),
                    call(socketSubscribeSaga, {
                        payload: { type: 'queue', domain: domain },
                    }),
                    call(socketSubscribeSaga, {
                        payload: { type: 'chat', user: user },
                    }),
                    call(socketSubscribeSaga, {
                        payload: { type: 'call', subtype: 'domain' },
                    }),
                ]);

            }
        }

    } catch (error) {
        console.error('Socket.IO error:', error);
        yield put(setIsConnected(false));

    }


}